(function () {
  const POPUP_SELECTOR = '.popup-custom';

  function now() {
    return Date.now();
  }

  function getRepeatMs(mode) {
    switch (mode) {
      case 'no_repeat': return Infinity;
      case 'every_30_mins': return 30 * 60 * 1000;
      case 'every_1_hr': return 60 * 60 * 1000;
      case 'every_6_hrs': return 6 * 60 * 60 * 1000;
      case 'every_12_hrs': return 12 * 60 * 60 * 1000;
      case 'every_day': return 24 * 60 * 60 * 1000;
      case 'every_3_days': return 3 * 24 * 60 * 60 * 1000;
      case 'every_week': return 7 * 24 * 60 * 60 * 1000;
      case 'every_2_weeks': return 14 * 24 * 60 * 60 * 1000;
      case 'every_month': return 30 * 24 * 60 * 60 * 1000;
      default: return 24 * 60 * 60 * 1000;
    }
  }

  function lockBody(lock) {
    document.documentElement.classList.toggle('popup-custom--open', lock);
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function initPopup(popup) {
    const id = popup.id || 'popup-custom';
    const storageKey = `popup_custom_last_seen_${id}`;

    const trigger = popup.dataset.triggerOpen || 'delay'; // immediately | delay | scroll_down
    const delayMs = parseInt(popup.dataset.delayMs || '3000', 10);
    const repeat = popup.dataset.repeatOpen || 'every_day';

    const showTeaser = popup.dataset.showTeaser === 'true';

    // Find teaser for THIS popup
    const teaser = document.querySelector(`[data-popup-teaser][data-popup-target="${id}"]`);
    const teaserDismissBtn = teaser ? teaser.querySelector('[data-popup-teaser-dismiss]') : null;

    function showTeaserTab() {
      if (!showTeaser || !teaser) return;
      teaser.removeAttribute('hidden');
    }

    function hideTeaserTab() {
      if (!teaser) return;
      teaser.setAttribute('hidden', 'true');
    }

    function hasCooldownPassed() {
      const last = Number(localStorage.getItem(storageKey) || '0');
      const ms = getRepeatMs(repeat);
      if (ms === Infinity) return last === 0;
      return now() - last >= ms;
    }

    function markSeen() {
      localStorage.setItem(storageKey, String(now()));
    }

    function open(force = false) {
      if (!force && !hasCooldownPassed()) return;
      hideTeaserTab();
      popup.removeAttribute('hidden');
      lockBody(true);
      markSeen();
    }

    function close() {
      popup.setAttribute('hidden', 'true');
      lockBody(false);
      showTeaserTab();
    }

    // Close handlers (overlay + X popup)
    popup.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    // ESC close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hasAttribute('hidden')) close();
    });

    // Teaser interactions
    if (teaser) {
      // Always start hidden; show only after close()
      hideTeaserTab();

      // Click anywhere on teaser (except dismiss) opens popup
      teaser.addEventListener('click', (e) => {
        const dismiss = e.target.closest('[data-popup-teaser-dismiss]');
        if (dismiss) return;
        open(true); // force open on teaser click
      });

      if (teaserDismissBtn) {
        teaserDismissBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          hideTeaserTab();
        });
      }
    }

    // Trigger open
    if (trigger === 'immediately') {
      open();
    } else if (trigger === 'scroll_down') {
      const onScroll = () => {
        if (window.scrollY > 300) {
          window.removeEventListener('scroll', onScroll);
          open();
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      window.setTimeout(() => open(), Math.max(0, delayMs));
    }
  }

  function boot() {
    // Do not run in Theme Editor (you handle open/close there)
    if (window.Shopify && Shopify.designMode) return;

    document.querySelectorAll(POPUP_SELECTOR).forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();